<template>
  <div>
    <br>
    <p>{{ getTranslations.home_modals_select_operator_my_operator_is }}</p>
    <div class="operators_selection_wrap ">
      <div class="operatorsmulti_radio">
        <label v-for="(op, index) in multiOperatorInfo.multiOperatorKeys"
               :key="index"
               class="operatorsmulti_radio operatorsmulti_radio_inline">
          <img class="operatorsmulti_icon"
               :src="getOperatorImage(index)"
               :alt="getOperatorDisplayName(index)">
          <input type="radio"
                 name="operator"
                 @click="onOperatorSelect(op)"
                 :value="op">
          <span></span>
        </label>
      </div>
      <div class="operators_error_msg"
           v-if="error">
      <span class="form-group__feedback">
         {{ getTranslations.visitor_sign_up_1_single_country_select_operator }}
      </span>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'OperatorSelection',
  props: ['error'],
  methods: {
    getOperatorDisplayName(operatorIndex) {
      return this.multiOperatorInfo.multiOperatorDisplayNames[operatorIndex];
    },
    getOperatorImage(operatorIndex) {
      return this.getTranslationByOperator(operatorIndex, 'visitor_sign_up_1_operator_image');
    },
    onOperatorSelect(operator) {
      this.$emit('choose', operator);
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/forgotPassword/OperatorSelection.vue